// ErrorList.js
import React from 'react';

const ErrorList = ({ errors, data, onFix, onDelete, onSkip, onSkipRemaining, onClose, onContinue, loading }) => {
  const getValueFromData = (lineData, field, message) => {
    if (!lineData || message !== "Value is not formatted correctly") return null;
    for (const key in lineData) {
      if (lineData[key]?.[field]?.value) {
        return lineData[key][field]["value"];
      }
    }
    return null;
  };

  const renderErrorList = (errors) => {
    return Object.entries(errors).map(([lineNumber, errorDetails]) => {
      const lineData = data[lineNumber];
      return (
        <div key={lineNumber}>
          <h4>{errorDetails.errorFor} (Line {lineNumber})</h4>
          <ul>
            {Object.entries(errorDetails)
              .filter(([field]) => field !== 'errorFor')
              .map(([field, message]) => {
                const value = getValueFromData(lineData, field, message);
                return (
                  <li key={field}>
                    <strong>{field}:</strong> {message}
                    {value ? `: ${value}` : ''}
                  </li>
                );
              })}
          </ul>
          <button onClick={() => onFix(lineNumber)}>Fix Errors</button>
          <button onClick={() => onSkip(lineNumber)}>Skip</button>
          <button onClick={() => onDelete(lineNumber)}>Delete</button>
        </div>
      );
    });
  };

  return (
    <div className="page-modal">
      <div className="modal">
        <div className="modal-content">
          <h3>Errors while importing data</h3>
          <div className="modal-scrollable">
            {renderErrorList(errors)}
          </div>
          <div className="modal-buttons">
            <button
              onClick={onContinue}
              disabled={Object.keys(errors).length > 0}
              style={{
                backgroundColor: Object.keys(errors).length > 0 ? 'gray' : 'blue',
                color: 'white',
                cursor: Object.keys(errors).length > 0 ? 'not-allowed' : 'pointer',
                opacity: Object.keys(errors).length > 0 ? 0.6 : 1,
              }}
            >
              {loading ? <div className="loading-spinner"></div> : "Continue"}
            </button>
            <button onClick={onSkipRemaining}>Skip remaining</button>
            <button onClick={onClose}>Discard changes</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorList;